const NodeName = Object.freeze({
    UNIT: 'COURSE_UNIT',
    PAGE: 'COURSE_PAGE',
});

export {NodeName};
